import type { UrlObject } from 'url';
import type { HTMLAttributes } from 'react';
import { useCallback } from 'react';
import classNames from 'classnames';
import { changeUrl, getUrlObject } from '$util/index';
import { SimpleLink } from '@/components/atoms/SimpleLink';

export interface LoginButtonProps extends HTMLAttributes<HTMLElement> {
  readonly returnTo?: UrlObject;
  readonly label?: string;
  readonly className?: string;
}

export function LoginButton({
  returnTo,
  label = 'Login',
  className,
  ...props
}: LoginButtonProps): JSX.Element {
  const clickLogin = useCallback(() => {
    if (typeof window === 'undefined') return;

    const returnUrlObj: UrlObject = getUrlObject(
      typeof returnTo === 'string' && returnTo ? returnTo : window.location.href
    );

    changeUrl({
      pathname: '/login',
      query: { returnTo: encodeURI(returnUrlObj.toString()) },
    });
  }, [returnTo]);

  return (
    <SimpleLink
      type={2}
      text={label}
      className={classNames('LoginButton', className)}
      {...props}
      onClick={(event) => {
        event.preventDefault();
        clickLogin();
      }}
    />
  );
}
